import { IPromise } from 'angular';
import * as _ from 'underscore';

import { getCommonDatasourceInfo } from '../../app/spaces/CommonDatasourceInfo';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { DatasourceDefinition } from '../models/ContentDefinitions';
import { IContentInfo } from '../models/IContentInfo';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { IChangeContentTagsAction, IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { INotificationTranslationIds } from './ContentActionNotification';
import { ModalService } from './ModalService';

export class ChangeContentTagsAction implements IChangeContentTagsAction {

  public static notificationTranslationIds: INotificationTranslationIds = {
    successId: 'changeTagsContentSuccess',
    errorId: 'changeTagsContentError'
  };

  public execute: (items: IContentInfo[], actionContext: IActionContext) => IPromise<IChangeContentTagsResult>;

  public static $inject = ['ChangeTagsActionHelperService', '$translate', 'ModalService'];

  constructor(
    ChangeTagsActionHelper: ChangeTagsActionHelperService,
    private $translate: ng.translate.ITranslateService,
    private ModalService: ModalService,
  ) {

    this.execute = ChangeTagsActionHelper.createExecuteFnForMixedContent({
      getDescription: (items: IContentInfo[]) => this.getDescription(items),
      notificationIds: ChangeContentTagsAction.notificationTranslationIds,
    });
  }

  private getDescription(items: IContentInfo[]) {
    return (items.length === 1)
      ? this.$translate.instant('changeTagsContentDescription', { NAME: L10n.elideIfLong(items[0].name) })
      : this.$translate.instant('changeTagsPluralContentDescription', { COUNT: items.length }, L10n.Interpolations.Count);
  }

  public showChangeTagsForMixedContentDialog(content: IContentInfo[], actionContext: IActionContext) {
    if (this.allContentIsEmbeddedDatasources(content)) {
      return this.ModalService.alert({
        titleId: 'changeTagsDatasource_cannotTagAlertTitle',
        messageId: 'changeTagsDatasource_cannotTagAlertMessage'
      }).result;
    }

    return this.execute(content, actionContext);
  }

  private allContentIsEmbeddedDatasources(allContent: IContentInfo[]): allContent is IContentInfo<'datasource'>[] {
    return _.all(allContent, item =>
      item.contentType === DatasourceDefinition.contentType && DataSources.isEmbedded(getCommonDatasourceInfo(item))
    );
  }
}

Module.instance().service('ChangeContentTagsAction', ChangeContentTagsAction);
